import Notification from "@/services/echo-manager/notification";

export default class InviteReceived extends Notification
{
    handle() {
        //
    }
}